// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccordionController from "./accordion_controller"
application.register("accordion", AccordionController)

import AlertController from "./alert_controller"
application.register("alert", AlertController)

import Analytics__PresentController from "./analytics/present_controller"
application.register("analytics--present", Analytics__PresentController)

import Analytics__PreviewController from "./analytics/preview_controller"
application.register("analytics--preview", Analytics__PreviewController)

import AnalyticsController from "./analytics_controller"
application.register("analytics", AnalyticsController)

import AnimateController from "./animate_controller"
application.register("animate", AnimateController)

import AriaController from "./aria_controller"
application.register("aria", AriaController)

import ArrayInputController from "./array_input_controller"
application.register("array-input", ArrayInputController)

import AttendanceController from "./attendance_controller"
application.register("attendance", AttendanceController)

import AttendanceRefreshController from "./attendance_refresh_controller"
application.register("attendance-refresh", AttendanceRefreshController)

import AutoRedirectController from "./auto_redirect_controller"
application.register("auto-redirect", AutoRedirectController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import AvatarUploadController from "./avatar_upload_controller"
application.register("avatar-upload", AvatarUploadController)

import BurgerController from "./burger_controller"
application.register("burger", BurgerController)

import Calendar__DragController from "./calendar/drag_controller"
application.register("calendar--drag", Calendar__DragController)

import Calendar__EventActionsController from "./calendar/event_actions_controller"
application.register("calendar--event-actions", Calendar__EventActionsController)

import Calendar__ExtendedHoverController from "./calendar/extended_hover_controller"
application.register("calendar--extended-hover", Calendar__ExtendedHoverController)

import Calendar__MenuLoaderController from "./calendar/menu_loader_controller"
application.register("calendar--menu-loader", Calendar__MenuLoaderController)

import Calendar__NavigationController from "./calendar/navigation_controller"
application.register("calendar--navigation", Calendar__NavigationController)

import Calendar__PopoverDragController from "./calendar/popover_drag_controller"
application.register("calendar--popover-drag", Calendar__PopoverDragController)

import CaretAtEndController from "./caret_at_end_controller"
application.register("caret-at-end", CaretAtEndController)

import CarouselController from "./carousel_controller"
application.register("carousel", CarouselController)

import Chart__HighlightController from "./chart/highlight_controller"
application.register("chart--highlight", Chart__HighlightController)

import Chart__LegendController from "./chart/legend_controller"
application.register("chart--legend", Chart__LegendController)

import Chart__LineHoverController from "./chart/line_hover_controller"
application.register("chart--line-hover", Chart__LineHoverController)

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import CheckboxesController from "./checkboxes_controller"
application.register("checkboxes", CheckboxesController)

import ClickController from "./click_controller"
application.register("click", ClickController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import ColorPickerController from "./color_picker_controller"
application.register("color-picker", ColorPickerController)

import ConditionalRenderController from "./conditional_render_controller"
application.register("conditional-render", ConditionalRenderController)

import ConfirmDestroyController from "./confirm_destroy_controller"
application.register("confirm-destroy", ConfirmDestroyController)

import CookieConsentController from "./cookie_consent_controller"
application.register("cookie-consent", CookieConsentController)

import DatePlaceholderController from "./date_placeholder_controller"
application.register("date-placeholder", DatePlaceholderController)

import DisableUntilSelectedController from "./disable_until_selected_controller"
application.register("disable-until-selected", DisableUntilSelectedController)

import DisclosureController from "./disclosure_controller"
application.register("disclosure", DisclosureController)

import DomSearchController from "./dom_search_controller"
application.register("dom-search", DomSearchController)

import DropzoneController from "./dropzone_controller"
application.register("dropzone", DropzoneController)

import DynamicSelectController from "./dynamic_select_controller"
application.register("dynamic-select", DynamicSelectController)

import EitherOrController from "./either_or_controller"
application.register("either-or", EitherOrController)

import EmbedController from "./embed_controller"
application.register("embed", EmbedController)

import EnableController from "./enable_controller"
application.register("enable", EnableController)

import FeedbacksController from "./feedbacks_controller"
application.register("feedbacks", FeedbacksController)

import FilepondController from "./filepond_controller"
application.register("filepond", FilepondController)

import FiltersController from "./filters_controller"
application.register("filters", FiltersController)

import FinalSlideController from "./final_slide_controller"
application.register("final-slide", FinalSlideController)

import FontSizeController from "./font_size_controller"
application.register("font-size", FontSizeController)

import FormController from "./form_controller"
application.register("form", FormController)

import FormResetController from "./form_reset_controller"
application.register("form-reset", FormResetController)

import GtmController from "./gtm_controller"
application.register("gtm", GtmController)

import HoverPreviewController from "./hover_preview_controller"
application.register("hover-preview", HoverPreviewController)

import HtmlAttributesController from "./html_attributes_controller"
application.register("html-attributes", HtmlAttributesController)

import HubspotChatController from "./hubspot_chat_controller"
application.register("hubspot-chat", HubspotChatController)

import IframeController from "./iframe_controller"
application.register("iframe", IframeController)

import InjectHtmlController from "./inject_html_controller"
application.register("inject-html", InjectHtmlController)

import InputCodeController from "./input_code_controller"
application.register("input-code", InputCodeController)

import JoinClassesController from "./join_classes_controller"
application.register("join-classes", JoinClassesController)

import JsonEditorController from "./json_editor_controller"
application.register("json-editor", JsonEditorController)

import KeyboardFocusController from "./keyboard_focus_controller"
application.register("keyboard-focus", KeyboardFocusController)

import LibraryTabController from "./library_tab_controller"
application.register("library-tab", LibraryTabController)

import LoadingController from "./loading_controller"
application.register("loading", LoadingController)

import LockRefreshController from "./lock_refresh_controller"
application.register("lock-refresh", LockRefreshController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import MultipleSearchController from "./multiple_search_controller"
application.register("multiple-search", MultipleSearchController)

import NavigateController from "./navigate_controller"
application.register("navigate", NavigateController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import NestedSortableController from "./nested_sortable_controller"
application.register("nested-sortable", NestedSortableController)

import PasswordHintController from "./password_hint_controller"
application.register("password-hint", PasswordHintController)

import PasswordToggleController from "./password_toggle_controller"
application.register("password-toggle", PasswordToggleController)

import PrefetchController from "./prefetch_controller"
application.register("prefetch", PrefetchController)

import PriorityLoaderController from "./priority_loader_controller"
application.register("priority-loader", PriorityLoaderController)

import ProgressController from "./progress_controller"
application.register("progress", ProgressController)

import ProgressTrackerController from "./progress_tracker_controller"
application.register("progress-tracker", ProgressTrackerController)

import PromptDismissalController from "./prompt_dismissal_controller"
application.register("prompt-dismissal", PromptDismissalController)

import QuestionSubmitGateController from "./question_submit_gate_controller"
application.register("question-submit-gate", QuestionSubmitGateController)

import RadioBackgroundController from "./radio_background_controller"
application.register("radio-background", RadioBackgroundController)

import RailsNestedFormController from "./rails_nested_form_controller"
application.register("rails-nested-form", RailsNestedFormController)

import RememberSelectController from "./remember_select_controller"
application.register("remember-select", RememberSelectController)

import RemoveElementController from "./remove_element_controller"
application.register("remove-element", RemoveElementController)

import RemoveShortcutController from "./remove_shortcut_controller"
application.register("remove-shortcut", RemoveShortcutController)

import RenderTemplateController from "./render_template_controller"
application.register("render-template", RenderTemplateController)

import RequestController from "./request_controller"
application.register("request", RequestController)

import RequiredFieldsSubmitController from "./required_fields_submit_controller"
application.register("required-fields-submit", RequiredFieldsSubmitController)

import ResendCountdownController from "./resend_countdown_controller"
application.register("resend-countdown", ResendCountdownController)

import RespondentVotesController from "./respondent_votes_controller"
application.register("respondent-votes", RespondentVotesController)

import ResponseBrowserController from "./response_browser_controller"
application.register("response-browser", ResponseBrowserController)

import ResponseLengthIndicatorController from "./response_length_indicator_controller"
application.register("response-length-indicator", ResponseLengthIndicatorController)

import ResumeRefreshController from "./resume_refresh_controller"
application.register("resume-refresh", ResumeRefreshController)

import RevealQuestionsController from "./reveal_questions_controller"
application.register("reveal-questions", RevealQuestionsController)

import RulesBuilderController from "./rules_builder_controller"
application.register("rules-builder", RulesBuilderController)

import ScrollbarController from "./scrollbar_controller"
application.register("scrollbar", ScrollbarController)

import SectionSlideController from "./section_slide_controller"
application.register("section-slide", SectionSlideController)

import SelectionCountController from "./selection_count_controller"
application.register("selection-count", SelectionCountController)

import SigningInController from "./signing_in_controller"
application.register("signing-in", SigningInController)

import SlidesController from "./slides_controller"
application.register("slides", SlidesController)

import SlidesEditorController from "./slides_editor_controller"
application.register("slides-editor", SlidesEditorController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import SortableQuestionController from "./sortable_question_controller"
application.register("sortable-question", SortableQuestionController)

import SparksController from "./sparks_controller"
application.register("sparks", SparksController)

import StarRatingController from "./star_rating_controller"
application.register("star-rating", StarRatingController)

import StickyController from "./sticky_controller"
application.register("sticky", StickyController)

import StudentProfileFormController from "./student_profile_form_controller"
application.register("student-profile-form", StudentProfileFormController)

import Table__ColumnVisibilityController from "./table/column_visibility_controller"
application.register("table--column-visibility", Table__ColumnVisibilityController)

import Table__SortController from "./table/sort_controller"
application.register("table--sort", Table__SortController)

import TextareaAutogrowController from "./textarea_autogrow_controller"
application.register("textarea-autogrow", TextareaAutogrowController)

import TippyController from "./tippy_controller"
application.register("tippy", TippyController)

import TippyHideController from "./tippy_hide_controller"
application.register("tippy-hide", TippyHideController)

import TiptapController from "./tiptap_controller"
application.register("tiptap", TiptapController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import ToggleTabsController from "./toggle_tabs_controller"
application.register("toggle-tabs", ToggleTabsController)

import TrixController from "./trix_controller"
application.register("trix", TrixController)

import TrixLimitController from "./trix_limit_controller"
application.register("trix-limit", TrixLimitController)

import UnsavedProgressController from "./unsaved_progress_controller"
application.register("unsaved-progress", UnsavedProgressController)

import UploadPreviewController from "./upload_preview_controller"
application.register("upload-preview", UploadPreviewController)

import VideoPlayerController from "./video_player_controller"
application.register("video-player", VideoPlayerController)

import WizardLockController from "./wizard_lock_controller"
application.register("wizard-lock", WizardLockController)

import YoutubeController from "./youtube_controller"
application.register("youtube", YoutubeController)

import ZoomNudgeController from "./zoom_nudge_controller"
application.register("zoom-nudge", ZoomNudgeController)
